
<template>
  <div
    v-if="isAuthenticated"
    class="owal-splitview__container"
  >
    <div class="owal-splitview__master-panel">
      <slot name="master" />
    </div>
    <div class="owal-splitview__detail-panel">
      <div class="owal-splitview__detail-slot">
        <slot name="detail" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OwalSplitviewLayout',
  props: {
    isAuthenticated: {
      type: Boolean,
    },
  },
}
</script>

<style scoped>
  .owal-splitview__container {
    display: grid;
    grid-template-columns: 30rem auto;
    grid-template-rows: 1fr;
    height: 100%;
    width: 100%;
  }

  .owal-splitview__master-panel {
    margin: 0;
    padding: 0;
    box-shadow: none;
    height: 100%;
  }

  .owal-splitview__detail-panel {
    position: relative;
    display: flex;
    margin: 0;
    padding: 0;
    height: 100vh;
  }

  .owal-splitview__detail-slot {
    display: flex;
    flex: 1;
    overflow: auto;
    height: 100vh;
  }

  .owal-splitview__detail-slot > * {
    width: 100%;
    height: 100%;
  }
</style>
